import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { CalcUtil } from '../../../commons/kymw00/calc-util.service';

import { KYMW0800InputModel } from '../../../commons/kymw08/kymw0800/vo/kymw0800-input.model';
import { KYMW0A00InputModel } from '../../../commons/kymw0a/kymw0a00/vo/kymw0a00-input.model';
import { KYMW0900InputModel } from '../../../commons/kymw09/kymw0900/vo/kymw0900-input.model';
import { NvalInputModel } from '../../../commons/kymw0a/kymw0a00/vo/nval-input.model';

import { KYMW1400Component } from './kymw1400.component';
import { KYMW1400KomaPageModel } from './kymw1400-koma-page/kymw1400-koma-page.model';
import { PageComponent } from './page/page.component';
import { SectionComponent } from './page/section.component';
import { KomaComponent } from './page/koma.component';
import { KYMW1400KomaPageComponent } from './kymw1400-koma-page/kymw1400-koma-page.component';
import { KYMW1402InputModel } from '../kymw1402/vo/kymw1402-input.model';
import { KYMW1404InputModel } from '../kymw1404/vo/kymw1404-input.model';
import { KYMW1407InputModel } from '../kymw1407/vo/kymw1407-input.model';
import { KYMW1409InputModel } from '../kymw1409/vo/kymw1409-input.model';
import { KYMW1406InputModel } from '../kymw1406/vo/kymw1406-input.model';
import { PlanSummaryTableModel } from './vo/plan-summary-table.model';
import { PageIDModel } from './vo/page-id.model';
import { KomaIDModel } from './vo/koma-id.model';
import { RegistGoodsModel } from './vo/regist-goods.model';
import { GoodsInfoModel } from './vo/goods-info.model';
import { DeleteKomaModel } from './vo/delete-koma.model';
import { LockKomaEditModel } from './vo/lock-koma-edit.model';
import { RegistKomaModel } from './vo/regist-koma.model';
import { RegistKomaGoodsModel } from './vo/regist-koma-goods.model';
import { UpdateKomaModel } from './vo/update-koma.model';
import { ReplaceKomaModel } from './vo/replace-koma.model';
import { ShiftKomaModel } from './vo/shift-koma.model';
import { KomaInfoModel } from './vo/koma-info.model';
import { Injectable } from "@angular/core";

/**
 * コマ割画面の値を管理するクラス
 *
 * @export KYMW1400Model
 * @class KYMW1400Model
 */
@Injectable()
export class KYMW1400Model {

  public kymw1400Component: KYMW1400Component = null;

  public leftView: KYMW1400KomaPageComponent = null;
  public rightView: KYMW1400KomaPageComponent = null;
  public disabledCloseFlg = Boolean(false);
  public disabledPageEditFlg = Boolean(false);
  public disabledAddEmptyKomaFlg = Boolean(false);
  public disabledDeleteKomaFlg = Boolean(false);
  public disabledDeleteAllKomaFlg = Boolean(false);
  public disabledHistoryFlg = Boolean(false);

  public singlePageFlg = Boolean(false);
  public komaImageViewFlg = Boolean(true);
  public komaTextViewFlg = Boolean(true);
  // ボタン画像（ページ編集）
  public srcPageEdit = './assets/icons/KYMW14/editpage.png';
  // ボタン画像（新規コマ追加）
  public srcAddKoma = './assets/icons/KYMW14/newkoma.png';
  // ボタン画像（選択コマ削除）
  public srcDelKoma = './assets/icons/KYMW14/deletekoma.png';
  // ボタン画像（全コマ削除）
  public srcDelAllKoma = './assets/icons/KYMW14/deleteallkoma.png';
  // ボタン画像（全コマ削除）
  public srcMarkDirection = './assets/icons/KYMW14/editdataoutput.png';

  // 左ページ表示フラグ
  public leftPageVisible = Boolean(true);
  // 右ページ表示フラグ
  public rightPageVisible = Boolean(true);

  /**
   * 左ページ選択フラグ
   * TRUE:左ページ選択、 FALSE:右ページ選択
   */
  public leftPageSelected = Boolean(true);

  /**
   * ページ幅
   */
  public pageWidth = Number(0);

  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * ページID（左）
   */
  public leftPageId = Number(-1);

  /**
   * ページID（右）
   */
  public rightPageId = Number(-1);

  /**
   * 商品情報表示用ＶＯ
   */
  public kymw1406VO: KYMW1406InputModel = new KYMW1406InputModel();

  /**
   * 企画商品情報ロック済みＰコード配列
   */
  public pcodeList: Array<any> = new Array<any>();

  /**
   * 更新フラグ(0:デフォルト、1:更新、2:削除、3:商品情報変更)
   * 更新後の子画面再表示で使用
   */
  public updateFlg = Number(0);

  /**
   * 権限「1」は閲覧モード「2」フルコントロール
   */
  public funcPermission = String('2');

  /**
   * 企画メンテで変更されたPコード
   * ※実績履歴の再表示で使用
   */
  public reloadPcode = String('xxxxxxxxxx');

  /**
   * 企画メンテで変更されたPコード
   * ※実績履歴の再表示で使用
   */
  public reloadPcodeList: Array<any> = null;

  /**
   * 商品情報・モードレス画面再表示フラグ
   */
  public kymw1406Flg = Boolean(false);

  /**
   * 企画情報メンテナンス・モードレス画面再表示フラグ
   */
  public kymw0900Flg = Boolean(false);
  /**
   * 掲載候補商品リストで選択された注文商品区分
   */
  public kymw1404OrderGoodsFlg = String('');

  /**
   * 掲載候補商品リストで選択された商品情報
   */
  public goodsItem: any = null;

  /**
   * 選択されているページを返却する
   *
   * @readonly
   * @type {PageComponent} ページ
   * @memberof KYMW1400Model
   */
  public get selectedPage(): PageComponent {
    if (this.leftPageSelected) {
      return this.leftView.page;
    } else {
      return this.rightView.page;
    }
  }

  /**
   * 選択されているKYMW1400KomaPageModelを返却する
   *
   * @readonly
   * @type {KYMW1400KomaPageModel}
   * @memberof KYMW1400Model
   */
  public get selectedPageManage(): KYMW1400KomaPageModel {
    if (this.leftPageSelected) {
      return this.leftManage;
    } else {
      return this.rightManage;
    }
  }

  /**
   * 選択されていないKYMW1400KomaPageModelを返却する
   *
   * @readonly
   * @type {KYMW1400KomaPageModel}
   * @memberof KYMW1400Model
   */
  public get unSelectedPageManage(): KYMW1400KomaPageModel {
    if (!this.leftPageSelected) {
      return this.leftManage;
    } else {
      return this.rightManage;
    }
  }

  /**
   * 選択されているKYMW1400KomaPageComponentを返却する
   *
   * @readonly
   * @type {KYMW1400KomaPageComponent}
   * @memberof KYMW1400Model
   */
  public get selectedPageViewHelper(): KYMW1400KomaPageComponent {
    if (this.leftPageSelected) {
      return this.leftView;
    } else {
      return this.rightView;
    }
  }

  /**
   * 選択されていないKYMW1400KomaPageComponentを返却する
   *
   * @readonly
   * @type {KYMW1400KomaPageComponent}
   * @memberof KYMW1400Model
   */
  public get unSelectedPageViewHelper(): KYMW1400KomaPageComponent {
    if (!this.leftPageSelected) {
      return this.leftView;
    } else {
      return this.rightView;
    }
  }

  /**
   * 選択されているSectionを返却する
   *
   * @readonly
   * @type {SectionComponent}
   * @memberof KYMW1400Model
   */
  public get selectedSection(): SectionComponent {
    return this.selectedPage.selectedSection;
  }

  /**
   * 選択されている受注コードを返却する
   *
   * @readonly
   * @type {string}
   * @memberof KYMW1400Model
   */
  public get selectedOrderCode(): string {
    return this.kymw1400Component.txi_OrderCode.selectedOrderCode;
  }

  /**
   * 選択されている媒体を返却する
   *
   * @readonly
   * @type {string}
   * @memberof KYMW1400Model
   */
  public get selectedMediumType(): string {
    return this.kymw1400Component.cmb_Medium.selectedMediumType;
  }

  /**
   * 選択されている媒体区分の媒体区分種別を返却する
   *
   * @readonly
   * @type {string} 媒体区分種別（0:通常媒体/1:いつでも注文媒体）
   * @memberof KYMW1400Model
   */
  public get selectedMediumTypeClass(): string {
    return this.kymw1400Component.cmb_Medium.selectedMediumTypeClass;
  }

  /**
   * 選択されている媒体の業態区分を返却する
   *
   * @readonly
   * @type {string} 業態区分（1:ウィークリー/2:デイリー/3：スポット/0：期間）
   * @memberof KYMW1400Model
   */
  public get selectedDutiesFormDiv(): string {
    return this.kymw1400Component.cmb_Medium.selectedDutiesFormDiv;
  }

  /**
   * 選択されているコマの商品の注文商品区分を返却する
   *
   * @readonly
   * @type {Array<any>}
   * @memberof KYMW1400Model
   */
  public get selectedKomaOrderGoodsFlg(): Array<any> {
    let orderGoodsFlg: Array<any> = new Array<any>();

    // ページ、またはセクションが未選択
    if (this.selectedPageManage.pageData == null ||
      this.selectedPageManage.pageData.SectionInfo == null) {
      // 空で返却
      return orderGoodsFlg;
    }

    // セクション情報が1件でもArrayとして扱う
    const sectionInfoList: Array<any> = this.selectedPageManage.pageData.SectionInfo;
    // セクション情報数分ループ
    for (let i = Number(0); sectionInfoList.length > i; i++) {
      // コマ情報が存在
      if (sectionInfoList[i].KomaInfo != null) {
        // コマ情報が1件でもArrayとして扱う
        const komaInfoList: Array<any> = sectionInfoList[i].KomaInfo;
        // コマ情報数分ループ
        for (let j = Number(0); komaInfoList.length > j; j++) {
          // 選択されたコマのコマIDと一致した場合
          if (komaInfoList[j].KomaID === this.selectedKomaId) {
            // レイアウト情報が存在
            if (komaInfoList[j].LayoutInfo != null) {
              // レイアウト情報が1件でもArrayとして扱う
              const layoutInfoList: Array<any> = komaInfoList[j].LayoutInfo;
              // 注文商品区分他レイアウト情報取得
              orderGoodsFlg = layoutInfoList;
              break;
            } else {
              break;
            }
          }
        }
      }
    }
    return orderGoodsFlg;
  }

  /**
   * 選択されている生協コードを返却する
   *
   * @readonly
   * @type {string}
   * @memberof KYMW1400Model
   */
  public get selectedCoopCode(): string {
    return this.selectedPageViewHelper.cmb_Coop.selectedCoopCode;
  }

  /**
   * 選択されていない生協コードを返却する
   *
   * @readonly
   * @type {string}
   * @memberof KYMW1400Model
   */
  public get unSelectedCoopCode(): string {
    return this.unSelectedPageViewHelper.cmb_Coop.selectedCoopCode;
  }

  /**
   * 選択されているページNUMを返却する
   *
   * @readonly
   * @type {string}
   * @memberof KYMW1400Model
   */
  public get selectedPageNum(): string {
    return this.selectedPageViewHelper.cmb_Page.selectedPageNum;
  }

  /**
   * 選択されているページ情報を返却する
   * 
   * @readonly
   * @type {string}
   * @memberof KYMW1400Model
   */
  public get selectedPageInfo() {
    return this.selectedPageViewHelper.cmb_Page.selectedPageInfo;
  }

  /**
   * 選択されているページIDを返却する
   *
   * @readonly
   * @type {string}
   * @memberof KYMW1400Model
   */
  public get selectedPageId(): string {
    return this.selectedPageViewHelper.cmb_Page.selectedPageId;
  }

  /**
   * 選択されているコマ操作区分
   *
   * @readonly
   * @type {string}
   * @memberof KYMW1400Model
   */
  public get selectedKomaOperation(): string {
    return this.selectedPageViewHelper.kymw1400KomaPageModel.komaType;
  }

  /**
   * 選択されているコマを返却する
   *
   * @readonly
   * @type {KomaComponent}
   * @memberof KYMW1400Model
   */
  public get selectedKoma(): KomaComponent {
    return this.selectedPage.selectedKoma;
  }

  /**
   * 選択されたコマID
   *
   * @readonly
   * @type {string}
   * @memberof KYMW1400Model
   */
  public get selectedKomaId(): string {
    if (this.selectedKoma == null) {
      return '';
    } else {
      return this.selectedKoma.komaId;
    }
  }

  /**
   * 左マネージャー取得
   *
   * @readonly
   * @type {KYMW1400KomaPageModel}
   * @memberof KYMW1400Model
   */
  public get leftManage(): KYMW1400KomaPageModel {
    return this.leftView.kymw1400KomaPageModel;
  }

  /**
   * 右マネージャー取得
   *
   * @readonly
   * @type {KYMW1400KomaPageModel}
   * @memberof KYMW1400Model
   */
  public get rightManage(): KYMW1400KomaPageModel {
    return this.rightView.kymw1400KomaPageModel;
  }

  /**
   * PlanSummaryTableVO取得
   *
   * @param {number} [selectedKbn=Number(0)] 0：選択、1：左、2：右
   * @returns {PlanSummaryTableModel}
   * @memberof KYMW1400Model
   */
  public getPlanSummaryTableVO(selectedKbn = Number(0)): PlanSummaryTableModel {
    const vo: PlanSummaryTableModel = new PlanSummaryTableModel();
    vo.orderCode = this.selectedOrderCode;
    vo.mediumType = this.selectedMediumType;

    if (selectedKbn === 1) {
      // 左
      vo.coopCode = this.leftView.cmb_Coop.selectedCoopCode;
      vo.pageNum = Number(this.leftView.cmb_Page.selectedPageNum);
    } else if (selectedKbn === 2) {
      // 右
      vo.coopCode = this.rightView.cmb_Coop.selectedCoopCode;
      vo.pageNum = Number(this.rightView.cmb_Page.selectedPageNum);
    } else {
      // 選択
      vo.coopCode = this.selectedCoopCode;
      vo.pageNum = Number(this.selectedPageNum);
    }
    return vo;
  }

  /**
   * PageIDVO取得
   *
   * @returns {PageIDModel}
   * @memberof KYMW1400Model
   */
  public getPageIDVO(): PageIDModel {
    const vo: PageIDModel = new PageIDModel();
    vo['pageID'] = Number(this.selectedPageId);
    return vo;
  }

  /**
   * KomaIDVO取得
   *
   * @param {string} [komaId=null] コマID
   * @returns {KomaIDModel}
   * @memberof KYMW1400Model
   */
  public getKomaIDVO(komaId: string = null): KomaIDModel {
    const vo: KomaIDModel = new KomaIDModel();
    if (!PlessViewUtilsSub.isEmpty(komaId)) {
      vo.komaID = Number(komaId);
      vo.mediumType = this.mediumType;
    } else {
      vo.komaID = Number(this.selectedKomaId);
      vo.mediumType = this.mediumType;
    }
    let orderGoodsFlgKoma: Array<any> = new Array<any>();
    let komaFlg = Boolean(false);							// 通常商品フラグ
    let nvalKomaFlg = Boolean(false);							// 1物N価商品フラグ
    let nvalWpKomaFlg = Boolean(false);							// Boolean(1物N価Ｗ掲載商品フラ)グ
    orderGoodsFlgKoma = this.selectedKomaOrderGoodsFlg; // 注文商品区分他レイアウト情報取得
    // 注文商品区分編集
    // コマの商品の注文商品区分を調べて、コマの商品の注文商品区分を確定する
    for (let i = Number(0); orderGoodsFlgKoma.length > i; i++) {
      // 注文商品区分 = 通常商品("01")
      if (orderGoodsFlgKoma[i].OrderGoodsFlg === '01') {
        // 通常商品フラグ  = true
        komaFlg = true;
      } else if (orderGoodsFlgKoma[i].OrderGoodsFlg === '02') {
        // 注文商品区分 = 1物N価商品("02")
        // 1物N価商品フラグ = true
        nvalKomaFlg = true;
      } else if (orderGoodsFlgKoma[i].OrderGoodsFlg === '03') {
        // 注文商品区分 = 1物N価Ｗ掲載商品("03")
        // 1物N価Ｗ掲載商品フラグ = true
        nvalWpKomaFlg = true;
      }
    }
    // コマの注文商品区分を確定
    // "01"：通常商品、"02"：1物N価商品、"03"：1物N価W掲載商品、"99"：通常商品と1物N価W掲載商品のマルチコマ
    // 通常商品フラグのみ「true」
    if ((komaFlg) && (!nvalKomaFlg) && (!nvalWpKomaFlg)) {
      // 注文商品区分 = 通常商品("01")
      vo.orderGoodsFlg = '01';
    } else if ((nvalKomaFlg) && (!komaFlg) && (!nvalWpKomaFlg)) {
      // 1物N価商品フラグ のみ「true」
      // 注文商品区分 = 1物N価商品("02")
      vo.orderGoodsFlg = '02';
    } else if ((nvalWpKomaFlg) && (!komaFlg) && (!nvalKomaFlg)) {
      // 1物N価Ｗ掲載商品フラグのみ「true」
      // 注文商品区分 = 1物N価Ｗ掲載商品("03")
      vo.orderGoodsFlg = '03';
    } else {
      // 上記以外
      // 注文商品区分 = 通常商品といつ注Ｗ掲載のマルチコマ("99")
      vo.orderGoodsFlg = '99';
    }
    return vo;
  }

  /**
   * RegistGoodsVO取得
   *
   * @param {Array<any>} goodsDataList 商品データリスト
   * @returns {RegistGoodsModel}
   * @memberof KYMW1400Model
   */
  public getRegistGoodsVO(goodsDataList: Array<any>): RegistGoodsModel {
    const goodsInfoVOList: Array<any> = new Array<any>();

    goodsDataList.forEach((vo) => {
      const goodsInfoVO: GoodsInfoModel = new GoodsInfoModel();

      goodsInfoVO.pCode = vo.pcode;
      goodsInfoVO.orderGoodsFlg = vo.orderGoodsFlg;
      goodsInfoVO.itemCode = vo.itemCode;
      goodsInfoVO.orderNum6Digits = vo.orderNum6Digits;
      goodsInfoVO.receiptSOrderCode = vo.receiptSOrderCode;
      goodsInfoVO.startOrderCode = vo.startOrderCode;
      goodsInfoVO.publishAmountLimitNum = CalcUtil.getPublishAmountLimitNum(this.selectedSection, this.selectedKoma);
      goodsInfoVOList.push(goodsInfoVO);
    });
    const vo2: RegistGoodsModel = new RegistGoodsModel();
    vo2.orderCode = this.selectedOrderCode;
    vo2.mediumType = this.selectedMediumType;
    vo2.coopCode = this.selectedCoopCode;
    vo2.pageNum = Number(this.selectedPageNum);
    vo2.sectionID = Number(this.selectedSection.sectionId);
    vo2.komaID = Number(this.selectedKoma.komaId);
    vo2.goodsInfoVOList = goodsInfoVOList;
    return vo2;
  }

  /**
   * GetDeleteKomaVO取得
   *
   * @returns {DeleteKomaModel}
   * @memberof KYMW1400Model
   */
  public getDeleteKomaVO(): DeleteKomaModel {
    const vo: DeleteKomaModel = new DeleteKomaModel();
    vo.orderCode = this.selectedOrderCode;
    vo.mediumType = this.selectedMediumType;
    vo.coopCode = this.selectedCoopCode;
    vo.pageNum = Number(this.selectedPageNum);
    vo.pageID = Number(this.selectedPage.pageId);
    if (this.selectedKoma != null) {
      vo.komaID = Number(this.selectedKoma.komaId);
    }
    vo.orderGoodsFlg = '';

    return vo;
  }

  /**
   * GetLockKomaEditVO取得
   *
   * @returns {LockKomaEditModel}
   * @memberof KYMW1400Model
   */
  public getLockKomaEditVO(): LockKomaEditModel {
    const vo: LockKomaEditModel = new LockKomaEditModel();
    vo.orderCode = this.selectedOrderCode;
    vo.mediumType = this.selectedMediumType;
    vo.coopCode = this.selectedCoopCode;
    vo.pageID = Number(this.selectedPage.pageId);
    vo.pageNum = Number(this.selectedPageNum);
    return vo;
  }

  /**
   * RegistKomaGoodsVO取得
   *
   * @param {string} sectionId セクションID
   * @param {KomaComponent} koma コマ
   * @returns {RegistKomaModel}
   * @memberof KYMW1400Model
   */
  public getRegistKomaVO(sectionId: string, koma: KomaComponent): RegistKomaModel {
    const vo: RegistKomaModel = new RegistKomaModel();
    vo.orderCode = this.selectedOrderCode;
    vo.mediumType = this.selectedMediumType;
    vo.coopCode = this.selectedCoopCode;
    vo.pageNum = Number(this.selectedPageNum);
    vo.sectionID = Number(sectionId);
    vo.positionX = koma.positionX;
    vo.positionY = koma.positionY;
    vo.sizeW = koma.sizeW;
    vo.sizeH = koma.sizeH;
    return vo;
  }

  /**
   * RegistKomaGoodsVO取得
   *
   * @param {Array<any>} komaInfoVOList
   * @returns {RegistKomaGoodsModel}
   * @memberof KYMW1400Model
   */
  public getRegistKomaGoodsVO(komaInfoVOList: Array<any>): RegistKomaGoodsModel {
    const vo: RegistKomaGoodsModel = new RegistKomaGoodsModel();
    vo.orderCode = this.selectedOrderCode;
    vo.mediumType = this.selectedMediumType;
    vo.coopCode = this.selectedCoopCode;
    vo.pageNum = Number(this.selectedPageNum);
    vo.orderGoodsFlg = komaInfoVOList[0].orderGoodsFlg;
    vo.komaInfoVOList = komaInfoVOList;
    return vo;
  }

  /**
   * UpdateKomaVO取得
   *
   * @param {KomaComponent} koma コマ
   * @returns {UpdateKomaModel}
   * @memberof KYMW1400Model
   */
  public getUpdateKomaVO(koma: KomaComponent): UpdateKomaModel {
    const vo: UpdateKomaModel = new UpdateKomaModel();

    vo.komaID = Number(koma.komaId);
    vo.sectionID = Number(koma.section.sectionId);
    vo.positionX = koma.positionX;
    vo.positionY = koma.positionY;
    vo.sizeW = koma.sizeW;
    vo.sizeH = koma.sizeH;
    vo.pageNum = Number(koma.page.pageNum);
    vo.publishAmountLimitNum = CalcUtil.getPublishAmountLimitNum(koma.section, koma);

    return vo;
  }

  /**
   * ReplaceKomaVO取得
   *
   * @param {KomaComponent} komaFr
   * @param {KomaComponent} komaTo
   * @returns {ReplaceKomaModel}
   * @memberof KYMW1400Model
   */
  public getReplaceKomaVO(komaFr: KomaComponent, komaTo: KomaComponent): ReplaceKomaModel {
    const vo: ReplaceKomaModel = new ReplaceKomaModel();

    vo.orderCode = this.selectedOrderCode;									// 受注コード
    vo.mediumType = this.selectedMediumType;									// 媒体区分
    vo.coopCode = this.selectedCoopCode;										// 生協コード
    vo.komaIDFr = Number(komaFr.komaId);										// コマＩＤ(入替元)
    vo.komaIDTo = Number(komaTo.komaId);										// コマＩＤ(入替先)
    vo.pageNumFr = Number(komaFr.page.pageNum);             // ページ番号(入替元)
    vo.pageNumTo = Number(komaTo.page.pageNum);             // ページ番号(入替元)
    vo.publishAmountFr = CalcUtil.getPublishAmountLimitNum(komaFr.section, komaFr);	// 掲載料掲載枠数(入替元)
    vo.publishAmountTo = CalcUtil.getPublishAmountLimitNum(komaTo.section, komaTo);	// 掲載料掲載枠数(入替先)
    return vo;
  }

  /**
   * ShiftKomaVO取得
   *
   * @param {KomaComponent} komaFr
   * @param {KomaComponent} komaTo
   * @returns {ShiftKomaModel}
   * @memberof KYMW1400Model
   */
  public getShiftKomaVO(komaFr: KomaComponent, komaTo: KomaComponent): ShiftKomaModel {
    const vo: ShiftKomaModel = new ShiftKomaModel();

    vo.orderCode = this.selectedOrderCode;									// 受注コード
    vo.mediumType = this.selectedMediumType;								// 媒体区分
    vo.coopCode = this.selectedCoopCode;										// 生協コード
    vo.pageNum = Number(this.selectedPageNum).toString();	  // ページ番号
    vo.komaIDFr = Number(komaFr.komaId);										// コマＩＤ(入替元)
    vo.komaIDTo = Number(komaTo.komaId);										// コマＩＤ(入替先)
    vo.sizeW = Number(komaFr.sizeW.toFixed(9));							// コマ幅
    vo.sizeH = Number(komaFr.sizeH.toFixed(9));							// コマ高さ
    return vo;
  }

  /**
   * KYMW1402InputVO取得
   *
   * @returns {KYMW1402InputModel}
   * @memberof KYMW1400Model
   */
  public getKYMW1402InputVO(): KYMW1402InputModel {
    // 『誌面印刷』画面を呼び出す。
    const vo: KYMW1402InputModel = new KYMW1402InputModel();
    vo.orderCode = this.selectedOrderCode;
    vo.mediumType = this.selectedMediumType;
    vo.coopCode = this.selectedCoopCode;
    return vo;
  }

  /**
   * KYMW1404InputVO取得
   *
   * @param {boolean} [updateFlg=false]
   * @returns {KYMW1404InputModel}
   * @memberof KYMW1400Model
   */
  public getKYMW1404InputVO(updateFlg = false): KYMW1404InputModel {
    // 『掲載候補商品リスト』画面を呼び出す。
    const vo: KYMW1404InputModel = new KYMW1404InputModel();
    if (updateFlg) {
      vo.processDiv = 2;
    } else {
      vo.processDiv = 1;
    }

    vo.orderCode = this.selectedOrderCode;
    vo.mediumType = this.selectedMediumType;
    vo.coopCode = this.selectedCoopCode;
    vo.pageNum = this.selectedPageNum;
    // コマ割画面で選択した媒体が「いつでも注文媒体」の場合
    if ('1' === this.selectedMediumTypeClass) {
      // 注文商品区分=02:いつでも注文商品で画面起動
      vo.orderGoodsFlg = '02';
    } else {
      // コマ割画面で選択した媒体が「通常媒体」の場合
      // コマ配置、アクティブなコマに配置、ドラッグ＆ドロップ完了時に
      // 掲載候補商品リストで選択した注文商品区分が「いつでも注文商品」の場合
      if (this.kymw1404OrderGoodsFlg === '02') {
        // 注文商品区分=02:いつでも注文商品で画面起動
        vo.orderGoodsFlg = '02';
      } else {
        // 上記以外の場合
        // 注文商品区分=01:通常注文商品で画面起動
        vo.orderGoodsFlg = '01';
      }
    }
    // 掲載候補商品リストで選択した注文商品区分を保持するパラメータを初期化する。
    this.kymw1404OrderGoodsFlg = '';
    if (!this.selectedPageViewHelper.kymw1400KomaPageModel.pageLock
      && this.selectedPageViewHelper.kymw1400KomaPageModel.komaType
      === this.selectedPageViewHelper.kymw1400KomaPageModel.KOMATYPE_MOVE) {
      vo.editMode = '0';
    } else {
      vo.editMode = '1';
    }
    if (PlessViewUtilsSub.isEmpty(this.selectedKomaId)) {
      vo.activeKomaFlag = 0;
    } else {
      vo.activeKomaFlag = 1;
    }

    // 業態区分
    vo.dutiesFormDiv = this.selectedDutiesFormDiv;

    return vo;
  }

  /**
   * KYMW1407InputVO取得
   *
   * @returns {KYMW1407InputModel}
   * @memberof KYMW1400Model
   */
  public getKYMW1407InputVO(): KYMW1407InputModel {
    const vo: KYMW1407InputModel = new KYMW1407InputModel();
    vo.orderCode = this.selectedOrderCode;
    vo.coopCode = this.selectedCoopCode;
    vo.komaId = this.selectedKomaId;
    vo.editMode = !this.selectedPageViewHelper.kymw1400KomaPageModel.pageLock;
    if (this.selectedKoma != null) {
      vo.goodsCount = this.selectedKoma.getPcodeList().length;
    }
    return vo;
  }

  /**
   * KYMW1409InputVO取得
   *
   * @returns {KYMW1409InputModel}
   * @memberof KYMW1400Model
   */
  public getKYMW1409InputVO(): KYMW1409InputModel {
    const vo: KYMW1409InputModel = new KYMW1409InputModel();
    vo.orderCode = this.selectedOrderCode;
    vo.coopCode = this.selectedCoopCode;
    if (this.selectedKoma != null) {
      vo.pCodeList = this.selectedKoma.getPcodeList();

      // 通常注文商品以外の場合
      if (vo.orderGoodsFlg === '02' || vo.orderGoodsFlg === '03') {
        // ページ、セクション情報が存在
        if (this.selectedPageManage.pageData != null &&
          this.selectedPageManage.pageData.SectionInfo != null) {
          // セクション情報が1件でもArrayとして扱う
          const sectionInfoList: Array<any> = this.selectedPageManage.pageData.SectionInfo;
          // セクション情報数分ループ
          for (let i = Number(0); sectionInfoList.length > i; i++) {
            // コマ情報が存在
            if (sectionInfoList[i].KomaInfo != null) {
              // コマ情報が1件でもArrayとして扱う
              const komaInfoList: Array<any> = sectionInfoList[i].KomaInfo;
              // コマ情報数分ループ
              for (let j = Number(0); komaInfoList.length > j; j++) {
                // 選択されたコマのコマIDと一致した場合
                if (komaInfoList[j].KomaID === this.selectedKomaId) {
                  // レイアウト情報が存在
                  if (komaInfoList[j].LayoutInfo != null) {
                    // レイアウト情報が1件でもArrayとして扱う
                    const layoutInfoList: Array<any> = komaInfoList[j].LayoutInfo;
                    // レイアウト情報が1件より多い場合
                    if (layoutInfoList.length > 1) {
                      // レイアウト情報数分ループ
                      for (let k = Number(0); layoutInfoList.length > k; k++) {
                        const nvalInput: NvalInputModel = new NvalInputModel();
                        nvalInput.receiptSOrderCode = layoutInfoList[k].ReceiptSOrderCode[0];
                        nvalInput.orderNum6Digits = layoutInfoList[k].OrderNum6Digits[0];
                        nvalInput.itemCode = layoutInfoList[k].ItemCode[0];
                        vo.NvalInputList.push(nvalInput);
                      }
                    } else if (layoutInfoList.length === 1) {
                      // レイアウト情報が1件の場合
                      vo.receiptSOrderCode = layoutInfoList[0].ReceiptSOrderCode[0];
                      vo.orderNum6Digits = layoutInfoList[0].OrderNum6Digits[0];
                      vo.itemCode = layoutInfoList[0].ItemCode[0];
                    }
                  }
                  break;
                }
              }
            }
          }
        }
      }
    }
    // * 0:編集可、1:編集不可(ロック時)
    if (!this.selectedPageViewHelper.kymw1400KomaPageModel.pageLock) {
      vo.editMode = '0';
    } else {
      vo.editMode = '1';
    }
    return vo;
  }

  /**
   * KYMW0800InputVO取得
   *
   * @returns {KYMW0800InputModel}
   * @memberof KYMW1400Model
   */
  public getKYMW0800InputVO(): KYMW0800InputModel {
    const vo: KYMW0800InputModel = new KYMW0800InputModel();
    vo.funcID = 'KYMW1400';
    vo.orderCode = this.selectedOrderCode;
    if (this.selectedKoma != null) {
      vo.pCodeList = this.selectedKoma.getGoodsList();
    } else if (this.reloadPcodeList != null) {
      vo.pCodeList = this.reloadPcodeList;
      // 初期化
      this.reloadPcodeList = null;
    }
    return vo;
  }

  /**
   * KYMW0A00InputVO取得
   *
   * @returns {KYMW0A00InputModel}
   * @memberof KYMW1400Model
   */
  public getKYMW0A00InputVO(): KYMW0A00InputModel {
    const vo: KYMW0A00InputModel = new KYMW0A00InputModel();
    // 注文商品区分他レイアウト情報
    let komaFlg = Boolean(false);				// 通常商品フラグ
    let nvalKomaFlg = Boolean(false);				// 1物N価商品フラグ
    let nvalWpKomaFlg = Boolean(false);				// 1物N価Ｗ掲載商品フラグ
    vo.formId = 'KYMW1400';
    if (this.selectedKoma != null) {
      vo.pcodeList = this.selectedKoma.getPcodeList();
      // 注文商品区分他レイアウト情報取得
      vo.orderGoodsFlgKoma = this.selectedKomaOrderGoodsFlg;
      // 注文商品区分編集
      // コマの商品の注文商品区分を調べて、コマの商品の注文商品区分を確定する
      for (let i = Number(0); vo.orderGoodsFlgKoma.length > i; i++) {
        // 注文商品区分 = 通常商品("01")
        if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '01') {
          // 通常商品フラグ  = true
          komaFlg = true;
        } else if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '02') {
          // 注文商品区分 = 1物N価商品("02")
          // 1物N価商品フラグ = true
          nvalKomaFlg = true;
        } else if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '03') {
          // 注文商品区分 = 1物N価Ｗ掲載商品("03")
          // 1物N価Ｗ掲載商品フラグ = true
          nvalWpKomaFlg = true;
        }
      }
      // コマの注文商品区分を確定
      // 通常商品、通常商品のみのマルチコマは”01”を設定
      // 1物N価商品、1物N価商品のみのマルチコマは”02”を設定
      // 1物N価Ｗ掲載商品、1物N価Ｗ掲載商品のみのマルチコマは”03”を設定
      // 通常商品といつ注Ｗ掲載のマルチコマは”99”を設定
      // 通常商品フラグのみ「true」
      // 通常商品フラグのみ「true」
      if ((komaFlg) && (!nvalKomaFlg) && (!nvalWpKomaFlg)) {
        // 注文商品区分 = 通常商品("01")
        vo.orderGoodsFlgKoma2 = '01';
      } else if ((nvalKomaFlg) && (!komaFlg) && (!nvalWpKomaFlg)) {
        // 1物N価商品フラグ のみ「true」
        // 注文商品区分 = 1物N価商品("02")
        vo.orderGoodsFlgKoma2 = '02';
      } else if ((nvalWpKomaFlg) && (!komaFlg) && (!nvalKomaFlg)) {
        // 1物N価Ｗ掲載商品フラグのみ「true」
        // 注文商品区分 = 1物N価Ｗ掲載商品("03")
        vo.orderGoodsFlgKoma2 = '03';
      } else {
        // 上記以外
        // 注文商品区分 = 通常商品といつ注Ｗ掲載のマルチコマ("99")
        vo.orderGoodsFlgKoma2 = '99';
      }
      // 通常注文商品以外の場合
      for (let l = Number(0); vo.orderGoodsFlgKoma.length > l; l++) {
        // いつでも注文商品、いつ注Ｗ掲載商品の場合
        if (vo.orderGoodsFlgKoma[l].OrderGoodsFlg === '02' || vo.orderGoodsFlgKoma[l].OrderGoodsFlg === '03') {
          // ページ、セクション情報が存在
          if (this.selectedPageManage.pageData != null
            && this.selectedPageManage.pageData.SectionInfo != null) {
            // セクション情報が1件でもArrayとして扱う
            const sectionInfoList: Array<any> = this.selectedPageManage.pageData.SectionInfo;
            // セクション情報数分ループ
            for (let i = Number(0); sectionInfoList.length > i; i++) {
              // コマ情報が存在
              if (sectionInfoList[i].KomaInfo != null) {
                // コマ情報が1件でもArrayとして扱う
                const komaInfoList: Array<any> = sectionInfoList[i].KomaInfo;
                // コマ情報数分ループ
                for (let j = Number(0); komaInfoList.length > j; j++) {
                  // 選択されたコマのコマIDと一致した場合
                  if (komaInfoList[j].KomaID === this.selectedKomaId) {
                    // レイアウト情報が存在
                    if (komaInfoList[j].LayoutInfo != null) {
                      // レイアウト情報が1件でもArrayとして扱う
                      const layoutInfoList: Array<any> = komaInfoList[j].LayoutInfo;
                      // レイアウト情報数分ループ
                      for (let k = Number(0); layoutInfoList.length > k; k++) {
                        const nvalInput: NvalInputModel = new NvalInputModel();
                        nvalInput.receiptSOrderCode = layoutInfoList[k].ReceiptSOrderCode;	// 受付開始受注コード
                        nvalInput.startOrderCode = layoutInfoList[k].StartOrderCode;		// 適応開始受注コード
                        nvalInput.orderNum6Digits = layoutInfoList[k].OrderNum6Digits;	// 注文コード6桁
                        nvalInput.itemCode = layoutInfoList[k].ItemCode;			// アイテムコード
                        // いつでも注文の商品情報
                        vo.NvalInputList.push(nvalInput);
                      }
                    }
                    break;
                  }
                }
              }
            }
          }
        }
      }
    }

    vo.coopCode = this.selectedCoopCode;
    vo.orderCode = this.selectedOrderCode;
    vo.editLockInfo = PlessViewUtilsSub.booleanTOString(this.selectedPageViewHelper.kymw1400KomaPageModel.pageLock);

    return vo;
  }

  /**
   * KYMW0900InputVO取得
   *
   * @returns {KYMW0900InputModel}
   * @memberof KYMW1400Model
   */
  public getKYMW0900InputVO(): KYMW0900InputModel {
    const vo: KYMW0900InputModel = new KYMW0900InputModel();
    vo.orderCode = this.selectedOrderCode;
    if (this.selectedKoma != null) {
      vo.pCodeList = this.selectedKoma.getPcodeList();
    }
    vo.MediumType = this.selectedMediumType;
    vo.lockInfo = PlessViewUtilsSub.booleanTOString(!this.selectedPageViewHelper.kymw1400KomaPageModel.pageLock);

    return vo;
  }

  /**
   * getKomaInfoVO取得
   *
   * @param {SectionComponent} section
   * @param {KomaComponent} koma
   * @param {string} [pCode='']
   * @param {string} [receiptSOrderCode='']
   * @param {string} [startOrderCode='']
   * @param {string} [orderNum6Digits='']
   * @param {string} [itemCode='']
   * @param {string} [orderGoodsFlg='']
   * @returns {KomaInfoModel}
   * @memberof KYMW1400Model
   */
  public getKomaInfoVO(section: SectionComponent, koma: KomaComponent, pCode = '', receiptSOrderCode = '',
    startOrderCode = '', orderNum6Digits = '', itemCode = '', orderGoodsFlg = ''): KomaInfoModel {
    const vo: KomaInfoModel = new KomaInfoModel();
    vo.sectionId = Number(section.sectionId);
    vo.positionX = koma.positionX;
    vo.positionY = koma.positionY;
    vo.sizeW = koma.sizeW;
    vo.sizeH = koma.sizeH;
    vo.pCode = pCode;
    vo.orderNum6Digits = orderNum6Digits;
    vo.receiptSOrderCode = receiptSOrderCode;
    vo.startOrderCode = startOrderCode;
    vo.itemCode = itemCode;
    vo.orderGoodsFlg = orderGoodsFlg;
    vo.publishAmountLimitNum = CalcUtil.getPublishAmountLimitNum(section, koma);
    return vo;
  }

  /**
   * 画面メニュー、ボタンの活性化・非活性化制御を行う
   *
   * @returns {void}
   * @memberof KYMW1400Model
   */
  public updateMenuAndButtonEnable(): void {
    // 受注コード未入力、媒体未選択の場合
    let enableFlg = Boolean(false);
    // enableFlg = false;
    if (!PlessViewUtilsSub.isEmpty(this.selectedOrderCode) && !PlessViewUtilsSub.isEmpty(this.selectedMediumType)) {
      enableFlg = true;
    }

    this.disabledCloseFlg = !enableFlg;
    this.disabledPageEditFlg = !enableFlg;
    this.disabledAddEmptyKomaFlg = !enableFlg;
    this.disabledDeleteKomaFlg = !enableFlg;
    this.disabledDeleteAllKomaFlg = !enableFlg;
    this.changeControlLock();

    this.leftView.kymw1400KomaPageModel.pageLockEnable =
      this.funcPermission === this.kymw1400Component.sharedModel.FUNC_PERMISSION_FULLCONTROL && enableFlg;
    this.leftView.kymw1400KomaPageModel.reloadEnable = enableFlg;
    this.leftView.kymw1400KomaPageModel.seqNoEnable = enableFlg;
    this.rightView.kymw1400KomaPageModel.pageLockEnable = enableFlg;
    this.rightView.kymw1400KomaPageModel.reloadEnable = enableFlg;
    this.rightView.kymw1400KomaPageModel.seqNoEnable = enableFlg;

    // いつでも注文媒体の場合
    if (this.selectedMediumTypeClass === '1') {
      this.disabledHistoryFlg = true;
    } else {
      // if (this.selectedKomaOrderGoodsFlg.length === 0) {
      if (PlessViewUtilsSub.isEmptyArray(this.selectedKomaOrderGoodsFlg)) {
        // 通常注文媒体の場合、実績履歴を活性
        this.disabledHistoryFlg = false;
      } else {
        let normalFlg = Boolean(false);
        const orderGoodsFlg: Array<any> = this.selectedKomaOrderGoodsFlg;
        // 注文商品区分リスト分ループ
        for (let i = Number(0); orderGoodsFlg.length > i; i++) {
          // 通常商品の場合
          if (orderGoodsFlg[i].OrderGoodsFlg === '01') {
            normalFlg = true;
            break;
          }
        }
        // 通常商品の場合
        if (normalFlg) {
          // 通常注文媒体の場合、実績履歴を活性
          this.disabledHistoryFlg = false;
        } else {
          // 上記以外の場合
          // 通常注文媒体以外の場合、実績履歴を非活性
          this.disabledHistoryFlg = true;
        }
      }
    }
    if (!enableFlg) {
      return;
    }

    this.selectedPageMenuAndButtonEnable();
    this.unSelectedPageMenuAndButtonEnable();
    this.kymw1400Component.updateMenuBar();
  }

  /**
   * 実績履歴ボタン＆メニュー活性、非活性化処理
   *
   * @memberof KYMW1400Model
   */
  public updateHistoryMenuAndButtonEnable(): void {
    // if (this.selectedKomaOrderGoodsFlg.length === 0) {
    if (PlessViewUtilsSub.isEmptyArray(this.selectedKomaOrderGoodsFlg)) {
      // 注文商品区分他商品レイアウトの項目長が0の場合（通常商品の場合）
      // 実績履歴を活性
      this.disabledHistoryFlg = false;
    } else {
      // 上記以外の場合
      let normalFlg = Boolean(false);
      const orderGoodsFlg: Array<any> = this.selectedKomaOrderGoodsFlg;
      // 注文商品区分他商品レイアウトの件数分ループ
      for (let i = Number(0); orderGoodsFlg.length > i; i++) {
        // 注文商品区分が通常商品の場合
        if (orderGoodsFlg[i].OrderGoodsFlg === '01') {
          normalFlg = true;
          break;
        }
      }
      if (normalFlg) {
        // 通常注文商品の場合、実績履歴を活性にする。
        this.disabledHistoryFlg = false;
      } else {
        // 上記以外の場合、実績履歴を非活性にする。
        this.disabledHistoryFlg = true;
      }
    }
  }

  /**
   * 選択ページボタンメニュー活性、非活性化処理
   *
   * @private
   * @returns {void}
   * @memberof KYMW1400Model
   */
  public selectedPageMenuAndButtonEnable(): void {
    // ページ未選択
    let enableFlg = Boolean(false);
    if (!PlessViewUtilsSub.isEmpty(this.selectedPageId)) {
      enableFlg = true;
    }
    this.disabledAddEmptyKomaFlg = !enableFlg;
    this.disabledDeleteKomaFlg = !enableFlg;
    this.disabledDeleteAllKomaFlg = !enableFlg;
    this.changeControlLock();
    this.selectedPageViewHelper.kymw1400KomaPageModel.pageLockEnable =
      this.funcPermission === this.kymw1400Component.sharedModel.FUNC_PERMISSION_FULLCONTROL && enableFlg;
    this.selectedPageViewHelper.kymw1400KomaPageModel.reloadEnable = enableFlg;
    this.selectedPageViewHelper.kymw1400KomaPageModel.seqNoEnable = enableFlg;
    if (!enableFlg) {
      return;
    }

    // 編集ロック
    enableFlg = false;
    if (this.selectedPageViewHelper.clsPageLock === this.selectedPageViewHelper.BUTTON_STYLE_SELECTED &&
      this.selectedPageViewHelper.kymw1400KomaPageModel.komaType === this.selectedPageViewHelper.kymw1400KomaPageModel.KOMATYPE_MOVE) {
      enableFlg = true;
    }
    this.disabledAddEmptyKomaFlg = !enableFlg;
    this.disabledDeleteKomaFlg = !enableFlg;
    this.disabledDeleteAllKomaFlg = !enableFlg;
    this.changeControlLock();
    this.selectedPageViewHelper.kymw1400KomaPageModel.seqNoEnable = enableFlg;
  }

  /**
   * 非選択ページボタンメニュー活性、非活性化処理
   *
   * @private
   * @returns {void}
   * @memberof KYMW1400Model
   */
  public unSelectedPageMenuAndButtonEnable(): void {
    // ページ未選択
    let enableFlg = Boolean(false);
    if (!PlessViewUtilsSub.isEmpty(this.unSelectedPageViewHelper.cmb_Page.selectedPageId)) {
      enableFlg = true;
    }
    this.unSelectedPageViewHelper.kymw1400KomaPageModel.pageLockEnable =
      this.funcPermission === this.kymw1400Component.sharedModel.FUNC_PERMISSION_FULLCONTROL && enableFlg;
    this.unSelectedPageViewHelper.kymw1400KomaPageModel.reloadEnable = enableFlg;
    this.unSelectedPageViewHelper.kymw1400KomaPageModel.seqNoEnable = enableFlg;
    if (!enableFlg) {
      return;
    }

    // 編集ロック
    enableFlg = false;
    if (!this.unSelectedPageManage.pageLock &&
      this.unSelectedPageViewHelper.kymw1400KomaPageModel.komaType === this.unSelectedPageViewHelper.kymw1400KomaPageModel.KOMATYPE_MOVE) {
      enableFlg = true;
    }
    this.unSelectedPageViewHelper.kymw1400KomaPageModel.seqNoEnable = enableFlg;

  }

  /**
   * ボタンコントロールの使用・アイコン制御
   *
   * @private
   * @memberof KYMW1400Model
   */
  private changeControlLock() {
    if (this.disabledAddEmptyKomaFlg) {
      this.srcAddKoma = './assets/icons/KYMW14/disablednewkoma.png';
    } else {
      this.srcAddKoma = './assets/icons/KYMW14/newkoma.png';
    }
    if (this.disabledDeleteKomaFlg) {
      this.srcDelKoma = './assets/icons/KYMW14/disableddeletekoma.png';
    } else {
      this.srcDelKoma = './assets/icons/KYMW14/deletekoma.png';
    }
    if (this.disabledDeleteAllKomaFlg) {
      this.srcDelAllKoma = './assets/icons/KYMW14/disableddeleteallkoma.png';
    } else {
      this.srcDelAllKoma = './assets/icons/KYMW14/deleteallkoma.png';
    }
    if (this.disabledPageEditFlg) {
      this.srcPageEdit = './assets/icons/KYMW14/disableeditpage.png';
    } else {
      this.srcPageEdit = './assets/icons/KYMW14/editpage.png';
    }
  }
}
